/* unplugin-vue-components disabled */import { render } from "./transDetail.vue?vue&type=template&id=5cd474ca&scoped=true"
import script from "./transDetail.vue?vue&type=script&lang=js"
export * from "./transDetail.vue?vue&type=script&lang=js"

import "./transDetail.vue?vue&type=style&index=0&id=5cd474ca&scoped=true&lang=css"

import exportComponent from "D:\\VueDev\\smnc-h5\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cd474ca"]])

export default __exports__